/* eslint-disable @typescript-eslint/no-explicit-any */
import type { BoxProps } from 'rebass/styled-components';

import { mediumBreakpoint } from '../../../../utils/breakpoints';
import { chunkArrayCategories } from '../../../../utils/common';
import { useCurrentBreakpoint } from '../../../../utils/hooks/breakpoints';
import { withErrorBoundary } from '../../../components';
import { CategoryCard } from '../../../components/Cards';

import { StyledVerticalCardContainer, StyledVerticalCategoryWrapper, StyledWrapper } from './Styled';

interface VerticalProps extends BoxProps {
  categories: any[];
  twoColumns?: boolean;
}

export const Vertical = ({ categories, twoColumns }: VerticalProps) => {
  const currentBreakpoint = useCurrentBreakpoint();
  const categoryChunkSize = currentBreakpoint === mediumBreakpoint || twoColumns ? 2 : 3;
  const chunkedCategories = chunkArrayCategories(categories, categoryChunkSize);

  return (
    <StyledWrapper>
      {chunkedCategories.map(({ chunk, key }) => (
        <StyledVerticalCardContainer key={key} className={`cards-${chunk.length}`} twoColumns={twoColumns}>
          {chunk.map(({ id, ...categoryRest }) => (
            <StyledVerticalCategoryWrapper key={id} className={`cards-${chunk.length}`} twoColumns={twoColumns}>
              <CategoryCard id={id} {...categoryRest} />
            </StyledVerticalCategoryWrapper>
          ))}
        </StyledVerticalCardContainer>
      ))}
    </StyledWrapper>
  );
};

export default withErrorBoundary(Vertical, { componentName: 'CategoryListingModule/Vertical' });
